import { mapState, mapGetters, mapActions } from 'vuex';
import { PERMISSION_MATRIX_ACTIONS } from '@/core/services/store/modules/permissionMatrix.module';

export const permissionMatrixMixin = {
  computed: {
    ...mapState('permissionMatrix', [
      'matrix',
      'activeModule',
      'loading',
      'errors',
    ]),

    ...mapGetters('permissionMatrix', [
      'getAvailableModules',
      'getCurrentModuleMatrix',
      'getModulePermissions',
      'getHasModuleAnyPermissions',
      'getLegacyPermissions',
      'getPermission',
      'getHasFunctionPermissions',
      'getIsModulePermissionChecked',
      'getIsModulePermissionIndeterminate',
      'getTotalPermissions',
    ]),
  },

  methods: {
    ...mapActions('permissionMatrix', [
      PERMISSION_MATRIX_ACTIONS.INITIALIZE_MATRIX,
      PERMISSION_MATRIX_ACTIONS.SET_ACTIVE_MODULE,
      PERMISSION_MATRIX_ACTIONS.UPDATE_PERMISSION,
      PERMISSION_MATRIX_ACTIONS.UPDATE_FUNCTION_PERMISSIONS,
      PERMISSION_MATRIX_ACTIONS.UPDATE_MODULE_PERMISSIONS,
      PERMISSION_MATRIX_ACTIONS.LOAD_PERMISSIONS,
      PERMISSION_MATRIX_ACTIONS.RESET_MODULE,
      PERMISSION_MATRIX_ACTIONS.VALIDATE_MATRIX,
      PERMISSION_MATRIX_ACTIONS.EXPORT_PERMISSIONS,
      PERMISSION_MATRIX_ACTIONS.IMPORT_PERMISSIONS,
    ]),

    /**
     * Initialize matrix
     */
    initializeMatrix() {
      this.$store.dispatch(
        `permissionMatrix/${PERMISSION_MATRIX_ACTIONS.INITIALIZE_MATRIX}`,
      );
    },

    /**
     * Set active module
     */
    setActiveModule(module) {
      this.$store.dispatch(
        `permissionMatrix/${PERMISSION_MATRIX_ACTIONS.SET_ACTIVE_MODULE}`,
        module,
      );
    },

    /**
     * Update permission
     */
    updatePermission(functionId, permissionType, value) {
      this.$store.dispatch(
        `permissionMatrix/${PERMISSION_MATRIX_ACTIONS.UPDATE_PERMISSION}`,
        {
          functionId,
          permissionType,
          value,
        },
      );
    },

    /**
     * Update function permissions
     */
    updateFunctionPermissions(functionId, permissions) {
      this.$store.dispatch(
        `permissionMatrix/${PERMISSION_MATRIX_ACTIONS.UPDATE_FUNCTION_PERMISSIONS}`,
        {
          functionId,
          permissions,
        },
      );
    },

    /**
     * Update module permissions
     */
    updateModulePermissions(permissionType, value) {
      this.$store.dispatch(
        `permissionMatrix/${PERMISSION_MATRIX_ACTIONS.UPDATE_MODULE_PERMISSIONS}`,
        {
          permissionType,
          value,
        },
      );
    },

    /**
     * Load permissions
     */
    loadPermissions(permissions) {
      this.$store.dispatch(
        `permissionMatrix/${PERMISSION_MATRIX_ACTIONS.LOAD_PERMISSIONS}`,
        permissions,
      );
    },

    /**
     * Reset module
     */
    resetModule() {
      this.$store.dispatch(
        `permissionMatrix/${PERMISSION_MATRIX_ACTIONS.RESET_MODULE}`,
      );
    },

    /**
     * Validate matrix
     */
    validateMatrix() {
      return this.$store.dispatch(
        `permissionMatrix/${PERMISSION_MATRIX_ACTIONS.VALIDATE_MATRIX}`,
      );
    },

    /**
     * Export permissions
     */
    exportPermissions() {
      return this.$store.dispatch(
        `permissionMatrix/${PERMISSION_MATRIX_ACTIONS.EXPORT_PERMISSIONS}`,
      );
    },

    /**
     * Import permissions
     */
    importPermissions(data) {
      this.$store.dispatch(
        `permissionMatrix/${PERMISSION_MATRIX_ACTIONS.IMPORT_PERMISSIONS}`,
        data,
      );
    },

    /**
     * Check if module permission is checked
     */
    isModulePermissionChecked(permissionType) {
      return this.getIsModulePermissionChecked(permissionType);
    },

    /**
     * Check if module permission is indeterminate
     */
    isModulePermissionIndeterminate(permissionType) {
      return this.getIsModulePermissionIndeterminate(permissionType);
    },

    getPermissionValue(functionId, permissionType) {
      return this.getPermission(functionId, permissionType);
    },

    hasFunctionPermissions(functionId) {
      return this.getHasFunctionPermissions(functionId);
    },
  },
};
